//TODO: Apply correct font when available in tokens
* {
  box-sizing: border-box;
}

:host {
  display: flex;
  padding: 32px 20px 32px 20px;
  background-color: $xp-ref-color-text-default-dark;
  gap: 10px;
  z-index: 2;
}

.content {
  width: 100%;
  height: 100%;
  padding: 0 40px 0 40px;
  gap: 24px;
  display: flex;
  align-items: center;
  .link-side {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 24px;
    > a {
      font: $xp-ref-font-paragraph-paragraph-long;
      font-size: 14px;
      color: $xp-ref-color-text-default-light;
      text-decoration: none;
      cursor: pointer;
    }
  }
  .logo-side {
    display: flex;
    flex-direction: column;
    color: $xp-ref-color-background-component-high-emphasis;
    .text {
      font: $xp-ref-font-paragraph-paragraph-long;
      font-size: 14px;
      color: $xp-ref-color-background-surface-high-emphasis;
      text-align: left;
    }
    .logos {
      display: flex;
      flex-direction: row;
      align-items: flex-end;
      font: $xp-ref-font-paragraph-paragraph-small;
      gap: 10px;
      .logo {
        height: 24px;
        object-fit: contain;
      }
    }
  }
  @include mobile {
    flex-direction: column-reverse;
    .logo-side {
      .text {
        text-align: center;
      }
    }
  }
  @include tablet {
    flex-direction: row;
    justify-content: space-around;
    .logo-side {
      .text {
        font: $xp-ref-font-paragraph-paragraph-small;
        color: $xp-ref-color-background-surface-high-emphasis;
        text-align: left;
      }
    }
  }
  @include desktop {
    flex-direction: row;
    justify-content: space-around;
    .logo-side {
      .text {
        font: $xp-ref-font-paragraph-paragraph-small;
        color: $xp-ref-color-background-surface-high-emphasis;
        text-align: left;
      }
    }
  }
}
